import { render, staticRenderFns } from "./activityVideoDetail.vue?vue&type=template&id=358891eb&scoped=true"
import script from "./activityVideoDetail.vue?vue&type=script&lang=js"
export * from "./activityVideoDetail.vue?vue&type=script&lang=js"
import style0 from "./activityVideoDetail.vue?vue&type=style&index=0&id=358891eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358891eb",
  null
  
)

export default component.exports